<template>
  <svg :class="svgClass" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
@media only screen and (min-width: 701px) {
  .svg-icon {
    width: 180px;
    height: 56px;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
}
@media only screen and (max-width: 700px) {
  .svg-icon {
    width: 9em;
    height: 2.8em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
}
</style>